import "./ProjectGallery.module.css";
import Header from "@/reusable_sections/Header";
import TransformationShowcase from "./sections/TransformationShowcase";
import OurBuiltLegacy from "./sections/OurBuiltLegacy";
import Footer from "@/reusable_sections/Footer";
export default function ProjectGalleryPage() {
  return <div>
      <Header />
      <TransformationShowcase />
      <OurBuiltLegacy />
      <Footer />
    </div>;
}